import PropTypes from "prop-types";

import MobileEventsListCard from "./MobileCardEventsListCard";

const MobileCardEventsList = ({
	events
}) => events.map((course) => <MobileEventsListCard course={course} key={course.id} />);

MobileCardEventsList.proptypes = {
	events: PropTypes.arrayOf(PropTypes.shape({}))
};

MobileCardEventsList.defaultProps = {
	events: []
};

export default MobileCardEventsList;
